const defaultTaskFilters = {
  search: '',
  status: ['open']
};

export default defaultTaskFilters;
